import moment from 'moment';
import { ActiveFilter, ControlListOptions, CrawlfishJob, CrawlfishJobWithPages, CreateCrawlfishJob, JobInfoState, JobListModalState, JobsDataState } from './crawler.interface';
import { JobMode } from './crawler.enums';

export const CrawlfishJobDefaultState: CrawlfishJob = {
    id: 0,
    created_at: '',
    updated_at: '',
    status: '',
    info: {
        elapsed: '',
        pages_complete: 0,
        pages_failed: 0,
        pages_other: 0,
        pages_queued: 0,
        pages_redirected: 0,
        pages_total: 0,
        selected: 0,
        typed_pages: ''
    },
    requested_uris: [],
    reviewed: false,
    sources: [],
    keywords: {
        body: [''],
        images: ['']
    },
    name: '',
    owner: '',
    rules: {
        prevent_reverse_crawl: true,
        max_page_count: 1000,
        max_crawl_depth: 2,
        mode: JobMode.Standard,
        footer_keywords: false,
    }
};

export const CreateNewJobDefaultState: CreateCrawlfishJob = {
    job_name: '',
    job_owner: '',
    domains: [
        {
            domain: '',
            source: '',
        }
    ],
    keywords: '',
    rules: {
        prevent_reverse_crawl: true,
        max_page_count: 1000,
        max_crawl_depth: 10,
        max_ai_input_tokens: 500,
        mode: JobMode.Standard,
        ai_typing: false,
        path_control: ControlListOptions.None,
        control_paths: [],
        footer_keywords: false,
    },
};

export const CrawlfishJobWithPagesDefaultState: CrawlfishJobWithPages = {
    id: 0,
    created_at: '',
    updated_at: '',
    status: '',
    info: {
        elapsed: '',
        pages_complete: 0,
        pages_failed: 0,
        pages_other: 0,
        pages_queued: 0,
        pages_redirected: 0,
        pages_total: 0,
        selected: 0,
        typed_pages: ''
    },
    requested_uris: [],
    sources: [],
    keywords: {
        body: [],
        images: []
    },
    pages: [],
    reviewed: false,
    rules: {
        prevent_reverse_crawl: true,
        max_page_count: 1000,
        max_crawl_depth: 2,
        mode: JobMode.Standard,
        footer_keywords: false,
    },
    name: '',
    owner: '',
};

export const JobsDataDefaultState: JobsDataState = {
    ResultCount: {
        Total: 0,
        Current: 0,
        Limit: 0,
        Offset: 0
    },
    loadedJobs: [],
    filteredJobs: [],
    activeFilters: [],
    emptyResultsMessage: null,
    isFilterInProgress: false,
    sortInfo: {
        sortIndex: 1,
        activeColumn: '',
    },
};

export const JobListDefaultModalState: JobListModalState = {
    isCreateJobModalOpen: false,
    isRecreateJobModalOpen: false,
    isWorkersModalOpen: false
};

export const JobsDataDefaultFilters: ActiveFilter[] = [
    { name: 'created_at', value: twoWeeksAgo() },
    { name: 'reviewed', value: 'false' }
];

export function twoWeeksAgo(): string {
    const jsToday = new Date();
    jsToday.setDate(jsToday.getDate() + 1);
    const today = moment(jsToday).format('MM-DD-YYYY').split('T')[0];
    const twoWeeksAgo = moment(jsToday).subtract(2, "weeks").format('MM-DD-YYYY').split('T')[0];

    return `${twoWeeksAgo}..${today}`;
}

export function assignDefaultFilterString(): string {
    let defaultFilters = '/?q=';
    // Past 2 Weeks
    const twoWeekRange = twoWeeksAgo();
    defaultFilters += `/created_at/range:${twoWeekRange}`;
    // Name not empty/null 
    defaultFilters += `/name/not:`;
    // Not Reviewed 
    defaultFilters += `/reviewed/false`;

    return defaultFilters;
}

export const JobInfoDefaultState: JobInfoState = {
    activeColumn: '',
    job_name: '',
    job_id: 0,
    info: {
        detail: '',
        elapsed: '',
        pages_complete: 0,
        pages_failed: 0,
        pages_other: 0,
        pages_queued: 0,
        pages_redirected: 0,
        pages_total: 0,
        selected: 0,
        typed_pages: '',
        domain_counts: [
            {
                domain: '',
                count: 0
            }
        ],
        domains_failed: 0,
    },
    isLoading: true,
    errorMessage: '',
    sortIndex: -1
};

export const UserRoles = {
    Client: 'client',
    ClientAdmin: 'clientadmin',
    HippaaOfficer: 'hippaaofficer',
    MasqueradeAdmin: 'masqueradeadmin',
    Staff: 'staff',
    Submitter: 'submitter',
    Superuser: 'superuser',
    Thirdparty: 'thirdparty',
    Vendor: 'vendor'
};